import * as React from "react"
import { Navigate, useLocation } from "react-router"

import { useCurrentUser } from "./auth-store"

/**
 * Route guard. Renders `children` when a session is present; otherwise
 * bounces to `/login?redirect=<the path they were trying to reach>` so the
 * login flow can send them back where they started.
 *
 * Guarding is intentionally client-only: the backend already refuses
 * requests without a valid JWT, so this only fixes the *display* — a
 * signed-out reviewer sees /login instead of a shell that will 401 every
 * data call. The server, not this component, is the security boundary.
 */
export function RequireAuth({ children }: { children: React.ReactNode }): JSX.Element {
  const user = useCurrentUser()
  const location = useLocation()

  if (!user) {
    const target = `${location.pathname}${location.search}`
    const isRoot = target === "/" || target === ""
    const redirect = isRoot ? "" : `?redirect=${encodeURIComponent(target)}`
    return <Navigate to={`/login${redirect}`} replace />
  }

  return <>{children}</>
}
